// Not shipped by @tabler/icons-react (only IconPhonePause exists) - built by
// swapping that icon's pause bars for a play triangle, in the same bounding
// box, to match the outline tabler icon set style/props.
export const IconPhonePlay = ({stroke = 2, size = 24, color = "currentColor", className = "", ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={["tabler-icon", "tabler-icon-phone-play", className].filter(Boolean).join(" ")}
      {...props}
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2"/>
      <path d="M17 3.8v3.4q0 .8 .68 .38l2.64 -1.66q.68 -.42 0 -.84l-2.64 -1.66q-.68 -.42 -.68 .38"/>
    </svg>
  );
};
